export default __webpack_public_path__ + "static/media/icon14.e1b96d32.svg";